import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import {
  debounce as _debounce,
  find as _find,
} from 'lodash';

import { src } from 'utils/imgix';
import { isRetina } from 'utils/isRetina';

import styles from './TransparentJPEG.css';

class TransparentJPEG extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImage: props.imageConfig[0],
      imageStyle: this.getImageStyle(props.imageConfig[0]),
      imgixSize: props.imageConfig[0].size,
    };
    this.setCurrentImage = this.setCurrentImage.bind(this);
    this.onResize = _debounce(this.setCurrentImage, 200);
  }

  componentDidMount() {
    window.addEventListener(`resize`, this.onResize);
    this.setCurrentImage();
  }

  componentWillUnmount() {
    window.removeEventListener(`resize`, this.onResize);
  }

  setCurrentImage() {
    const currentImage = _find(this.props.imageConfig, (item) => {
      return window.matchMedia(item.media).matches;
    });

    if (currentImage) {
      this.setState({
        currentImage,
        imageStyle: this.getImageStyle(currentImage),
        imgixSize: isRetina() ? Math.round(currentImage.size * 1.5) : currentImage.size,
      });
    }
  }

  getImageStyle(image) {
    return {
      paddingTop: `${parseFloat((image.height / image.width * 100).toFixed(5))}%`,
    };
  }

  renderShadow() {
    if (!this.state.currentImage.shadow) {
      return null;
    }

    const shadowClass = classNames(styles[`shadow`], {
      [this.props.shadowClass]: this.props.shadowClass,
    });

    return (
      <img
        alt=""
        className={shadowClass}
        ref={(el) => { this.shadow = el; }}
        src={src(this.state.currentImage.shadow, this.state.currentImage.size)}
      />
    );
  }

  render() {
    const imageClass = classNames(styles[`image`], {
      [this.props.imageClass]: this.props.imageClass,
    });

    return (
      <div
        className={styles[`container`]}
        role="presentation"
        style={this.state.imageStyle}
      >
        {this.renderShadow()}
        <svg
          className={imageClass}
          preserveAspectRatio="xMinYMin"
          ref={(el) => { this.image = el; }}
          viewBox={`0 0 ${this.state.currentImage.width} ${this.state.currentImage.height}`}
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>{this.props.description}</title>
          <desc>{this.props.description}</desc>
          <defs>
            <mask id={`mask-${this.props.id}`}>
              <image
                height={this.state.currentImage.height}
                width={this.state.currentImage.width}
                xlinkHref={src(this.state.currentImage.mask, this.state.imgixSize)}
              />
            </mask>
          </defs>
          <image
            height={this.state.currentImage.height}
            mask={`url(#mask-${this.props.id})`}
            width={this.state.currentImage.width}
            xlinkHref={src(this.state.currentImage.main, this.state.imgixSize)}
          />
        </svg>
      </div>
    );
  }
}

TransparentJPEG.propTypes = {
  description: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  imageClass: PropTypes.string,
  imageConfig: PropTypes.arrayOf(
    PropTypes.shape({
      height: PropTypes.number.isRequired,
      main: PropTypes.string.isRequired,
      mask: PropTypes.string.isRequired,
      media: PropTypes.string.isRequired,
      shadow: PropTypes.string,
      size: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
    })
  ).isRequired,
  shadowClass: PropTypes.string,
};

export default TransparentJPEG;
